import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import s from './MonetizationPromoStrip.scss';
export const MonetizationPromoStrip = ({ monetizationPromo, className })=>{
    const { t } = useTranslation();
    const seller_promo_banners = useFlag('seller_promo_banners');
    if (![
        'tier',
        'commission',
        'premium_gallery',
        'adoptable',
        'pcp'
    ].includes(monetizationPromo)) {
        return null;
    }
    let bodyKey;
    let badgePromo = monetizationPromo;
    if (seller_promo_banners) {
        if (monetizationPromo === 'tier') {
            bodyKey = 'seller_promo_banners.avatar.monetizationPromoStrip.var.tier.body';
        } else {
            bodyKey = 'seller_promo_banners.avatar.monetizationPromoStrip.var.generic.body';
            badgePromo = 'generic';
        }
    } else {
        bodyKey = `avatar.monetizationPromoStrip.var.${monetizationPromo}.body`;
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: badgePromo,
        size: 24,
        className: s['badge']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(bodyKey))));
};
MonetizationPromoStrip.displayName = 'MonetizationPromoStrip';
export default MonetizationPromoStrip;
